import Vue from 'vue'

Vue.component('form-group', () => import('./FormGroup'))
Vue.component('login-form', () => import('./LoginForm'))